import { css } from '@emotion/react'
import { Tag } from 'bold-ui'
import { pink, purple } from 'bold-ui/lib/styles/colors'
import { TipoAtendimentoPainelChamadaEnum } from 'view/atendimentos/list/actions/chamar/model-painelChamada'

interface TagTipoAtendimentoPainelChamadaProps {
  tipoAtendimento: TipoAtendimentoPainelChamadaEnum
}

const tagVariant = {
  [TipoAtendimentoPainelChamadaEnum.ACOLHIMENTO]: css`
    background-color: ${pink.c60};
  `,
  [TipoAtendimentoPainelChamadaEnum.ATENDIMENTO]: css`
    background-color: ${purple.c60};
  `,
}

export function TagTipoAtendimentoPainelChamada(props: Readonly<TagTipoAtendimentoPainelChamadaProps>) {
  const { tipoAtendimento } = props
  const variantStyle = tagVariant[tipoAtendimento]

  return (
    <Tag style={[variantStyle, styles.tagText]} height='2rem'>
      {tipoAtendimento.titleCase()}
    </Tag>
  )
}

const styles = {
  tagText: css`
    font-size: 1.5rem;
    line-height: 1.5;
  `,
}
